import { Calendar } from "@/components/ui/calendar";
import { useWeekStartsOn } from "@/lib/dates/useWeekStartsOn";
import type { ComponentProps } from "react";

export function AppCalendar({
  weekStartsOn,
  ...props
}: ComponentProps<typeof Calendar>) {
  const sessionWeekStartsOn = useWeekStartsOn();

  return (
    <Calendar {...props} weekStartsOn={weekStartsOn ?? sessionWeekStartsOn} />
  );
}
